import png from './images/bulldogs.png'

export const colors = {
  dominant: '#0066B3',
  highlight: '#fcb53e',
}
export const fullname = 'Bulldogs'
export const badge = png


// WEBPACK FOOTER //
// ./src/nrl-teams/bulldogs.js